import { MANAGE_SEATS_TITLE, ManageSeatsDialog } from "@components/table/members/assign-seats/manage-seats-dialog";
import { MenuItem, SeatIcon } from "@flat-ui";
import { useState } from "react";
/**
 * Menu item that lets the user change the seats of a member in a dialog: give them a seat they do
 * not hold yet, or take their SCENE seat away again.
 *
 * The seats column offers the same dialog while a row is hovered, but only to assign a seat and in
 * a way that is easy to miss, so the menu spells it out.
 */
export function ManageSeatsMenuButton({
  member,
  onMenuClose
}) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  return <>
      <MenuItem label={MANAGE_SEATS_TITLE} Icon={SeatIcon} onClick={() => setIsDialogOpen(true)} />

      <ManageSeatsDialog member={member} isOpen={isDialogOpen} onClose={closeDialog} />
    </>;

  /** Closes the dialog and the 3-dot menu it was opened from */
  function closeDialog() {
    setIsDialogOpen(false);
    onMenuClose();
  }
}